import { useReferrals } from "@bounce/referrals"

import { useStoreSuggestions } from "@/components/LuggageStorage/Store/hooks/useStoreSuggestions"
import type { CityData } from "@/libs/bounce/cities"

type UseInteractiveMapFlagProps = {
  city: CityData
}

export const useInteractiveMapFlag = ({ city }: UseInteractiveMapFlagProps) => {
  const { coupon } = useReferrals.useCodes()
  const { handleGetStoreUrl } = useStoreSuggestions({
    couponCode: coupon,
    from: "City",
    searchQuery: city.query,
  })

  return {
    // Force push the interactive map, even if the exp is not stag sig we want to get more data for SEO (4 weeks of data)
    isInteractiveMapEnabled: true,
    handleGetStoreUrl,
  }
}
